import { Autocomplete, Box, FormControl, Icon, Switch, TextField, Typography } from "@mui/material";
import { DataGrid, GridEditInputCell, useGridApiRef } from "@mui/x-data-grid";
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import SubmitButton from "../UI/SubmitButton";
import { useEffect, useState, useCallback } from "react";
import EntryButton from "../UI/EntryButton";
import { useDispatch, useSelector } from "react-redux";
import { vendorProductsAction } from "../asyncActions/vendorActions";
import { addVendorDocumentData, clearData, removeVendorDocumentData, setVendorDocumentData, tooglePriceVendorDocument } from "../store/gridDataSlice";
import AddIcon from '@mui/icons-material/Add';
import SendIcon from '@mui/icons-material/Send';
import { clearFilterVendor, setProductVendor, setSelectFilter } from "../store/vendorSlice";
import { Link } from "react-router-dom";
import { setModal } from "../store/modalSlice";
import { useTranslation } from "react-i18next";
import { getManufactureProductListAction } from "../asyncActions/productAction";


function ManufacturePage() {

    const { t } = useTranslation()

    const apiRef = useGridApiRef()
    const dispatch = useDispatch()

    const {
        productList,
        selectFilter
    } = useSelector(store => store.vendor)

    const {
        vendorDocumentData
    } = useSelector(store => store.gridData)

    const [error, setError] = useState(null)

    const {role} = useSelector(store => store.authorization)

    const rows = vendorDocumentData

    const columns = [
        {
            field: 'action',
            type: 'actions',
            headerName: t('grid.action'),
            maxWidth: 80,
            renderCell: (params) => {
                const id = params.row.id
                return (
                    <Box>
                        <Icon component={DeleteIcon} onClick={() => {
                            dispatch(removeVendorDocumentData(id))
                        }} />
                    </Box>
                )
            }
        },
        {
            field: 'id',
            headerName: 'id',
            maxWidth: 80,
        },
        {
            field: 'name',
            headerName: t('grid.product_name'),
            minWidth: 150,
            flex: 1
        },
        {
            field: 'unit_type',
            headerName: t('grid.unit_type'),
            maxWidth: 80,
            flex: 1
        },
        {
            field: 'quantity',
            headerName: t('grid.qnt'),
            editable: true,
            type: 'number',
            minWidth: 80,
            flex: 1
        }
    ]


    function addHandle(e) {
        e.preventDefault()
        const findProduct = productList.find(elem => elem.id === selectFilter.product.id)
        if (findProduct) {
            let copyProduct = { ...findProduct, quantity: 0, avg_price: 0, price: 0, typePrice: true }
            copyProduct.vendor = findProduct.vendor?.name

            if (!rows.some(el => el.id === copyProduct.id)) {
                dispatch(addVendorDocumentData(copyProduct))
                // console.log(copyProduct)
                setError(null)
            } else {
                setError('Product already exist')
            }
        } else {
            setError('Vendor requared')

        }

    }

    function onEdit(row) {
        dispatch(setVendorDocumentData(row))
        return row
    }

    function onSubmit() {
        if (vendorDocumentData.every(elem => elem.quantity > 0 )) {
            dispatch(setModal({ active: true, content: 'documentVendorCreate', data: 'manufacture' }))
            console.log(vendorDocumentData)
            setError(null)
        } else {
            setError('Products with 0 quantity not allowed')
        }
    }

    function setClear() {
        dispatch(clearData('vendorDocumentData'))
    }

    useEffect(() => {
        dispatch(getManufactureProductListAction())
        return () => setClear()
    }, [dispatch])


    const handleCellClick = useCallback((params) => {
        try {
            apiRef.current.startCellEditMode({
                id: params.id,
                field: params.field,
            })
        } catch (e) {
        }
    },
        [apiRef],
    );

    const productsOption = productList.map(el => ({ label: el.name, id: el.id }))

    const handleChangeProduct = (_, value) => {
        dispatch(setSelectFilter({ filter: 'product', value: value }))

    }

    return (
        <Box sx={{
            height: '100%',
            width: '100%'
        }}>
            <Box sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: 4,
                height: '100%',
            }}>
                <Typography variant="h4" align="center">Manufacture</Typography>
                {error && <Typography sx={{ color: 'red',  }} align="center">{error}</Typography>}
                <Box sx={{
                    display: "flex",
                    gap: 5,
                    justifyContent: 'center'
                }} component='form' onSubmit={addHandle}>
                    <FormControl disabled={!selectFilter.vendor} sx={{ width: '250px' }}>
                        <Autocomplete
                            disablePortal
                            options={productsOption}
                            onChange={handleChangeProduct}
                            sx={{ width: "250px" }}
                            renderInput={(params) => {
                                return <TextField disabled={!selectFilter.vendor} {...params} label="Product" />
                            }}
                        />
                    </FormControl>

                    <SubmitButton endIcon={<AddIcon />} type='submit'>{t('button.add')}</SubmitButton>

                </Box>
                <Box sx={{
                    height: '100%'
                }}>
                    <DataGrid
                        getRowId={(row) => row.id}
                        apiRef={apiRef}
                        rows={rows}
                        onCellClick={handleCellClick}
                        columns={columns}
                        processRowUpdate={onEdit}
                        onProcessRowUpdateError={(e) => console.log(e)}
                        disableRowSelectionOnClick
                        sx={{
                            minHeight: '150px'
                        }}
                    />
                </Box>
                <Box sx={{
                    display: 'flex',
                    justifyContent: 'space-between'
                }}>
                    <EntryButton disabled={!rows.length} endIcon={<DeleteIcon />} onClick={setClear}>{t('button.clear')}</EntryButton>
                    <Box sx={{ display: 'flex', gap: '10px' }}>
                        <Link to='/admission/list'>
                            <SubmitButton>{t('button.all_admissions')}</SubmitButton>
                        </Link>
                        <SubmitButton disabled={!rows.length} endIcon={<SendIcon />} onClick={onSubmit}>{t('button.submit')}</SubmitButton>

                    </Box>
                </Box>

            </Box>
        </Box>
    )
}


export default ManufacturePage